export const placesWorkLocationInOffice = "Hlp9Lc";
export const placesWorkLocationRemote = "cbek2d";
export const placesWorkLocationAway = "GWCKBb";
export const placesWorkLocationNone = "GVcafd";
export default {placesWorkLocationInOffice,placesWorkLocationRemote,placesWorkLocationAway,placesWorkLocationNone};